'use strict';

require("core-js/modules/es6.object.assign");

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _styledSystem = require('styled-system');

var getWidth = function getWidth(n, scale) {
  if (!(0, _styledSystem.num)(n)) {
    return (0, _styledSystem.px)((0, _styledSystem.get)(scale, n, n));
  }

  if (n > 1) {
    return (0, _styledSystem.px)(n);
  }

  return n * 100 + '%';
};

var createSizeProp = function createSizeProp(prop) {
  return (0, _styledSystem.style)({
    prop: prop,
    transformValue: getWidth,
    key: 'sizes'
  });
};

var width = createSizeProp('width');
var height = createSizeProp('height');
var minWidth = createSizeProp('minWidth');
var maxWidth = createSizeProp('maxWidth');
var minHeight = createSizeProp('minHeight');
var maxHeight = createSizeProp('maxHeight');
var size = (0, _styledSystem.mapProps)(function (props) {
  return _extends({}, props, {
    width: props.size,
    height: props.size
  });
})((0, _styledSystem.compose)(width, height));
exports["default"] = (0, _styledSystem.compose)(_styledSystem.display, width, height, minWidth, maxWidth, minHeight, maxHeight, size, _styledSystem.verticalAlign, _styledSystem.overflow);
module.exports = exports['default'];